<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { EllipsisHorizontalCircleIcon } from '@heroicons/vue/24/outline';
import useLayout from '@/useLayout';
import BaseLayout from './BaseLayout.vue';
import SimulationRightSidebar from '@/Components/SimulationRightSidebar.vue';

const props = defineProps({
    simulation: { type: Object, required: true },
    humanReadableScenarioDescription: { type: String, required: false },
    previousRuns: { type: Array, required: true },
    playlists: { type: Array, required: false },
});

const page = usePage();
const authUser = computed(() => page.props.auth.user);
const { isRightSidebarOpen } = useLayout();
</script>

<template>
    <BaseLayout :withLeftSidebar="authUser && !authUser.isDemoUser" :withFooter="false" class="bg-white" navbar-background="white-fade">
        <template #mobile-navbar-title>
            <slot name="mobile-navbar-title"></slot>
        </template>
        <template #right-sidebar-trigger>
            <EllipsisHorizontalCircleIcon 
                @click="isRightSidebarOpen = true" 
                class="w-10 h-10 rounded-full transition-all duration-300 ease-in-out"
                :class="[isRightSidebarOpen ? 'opacity-0' : 'opacity-100']"
            />
        </template>
        <slot></slot>

        <template #rightSidebar>
            <SimulationRightSidebar :simulation="simulation" :humanReadableScenarioDescription="humanReadableScenarioDescription" :previousRuns="previousRuns" :playlists="playlists">
                <template #actions>
                    <slot name="rightSidebarActions"></slot>
                </template>
            </SimulationRightSidebar>
        </template>
    </BaseLayout>
</template>
